"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputWrapper = void 0;

var _util = require("../../../util");

const inputWrapper = ({
  theme
}) => ({
  height: '64px !important',
  '& input': { ...(0, _util.textStyle)(theme, 'heading1')
  }
});

exports.inputWrapper = inputWrapper;
//# sourceMappingURL=CurrencyInputField.style.js.map